import Vue from 'vue';
// import VueCookies from 'vue-cookies';

// Lib imports
import applyConverters from 'axios-case-converter';
import axios from 'axios';

import store from '@/store';

const instance = applyConverters(axios.create());

instance.interceptors.request.use(config => {
  // TODO replace auth/getToken with auth/getShopifyToken once backend implementation is ready
  if (store.getters['auth/getToken']) {
    config.baseURL = `${process.env.VUE_APP_API_ENDPOINT}/api/shops/${store.getters['auth/getShopId']}`;
    config.headers.Authorization = `Bearer ${store.getters['auth/getToken']}`;
  }
  return config;
});

instance.interceptors.response.use(
  resp => {
    return resp;
  },
  error => {
    if (error.response && (!error.response || error.response.status === 401)) {
      if (process.env.NODE_ENV === 'production' && !(window.shopify || window.Shopify)) {
        localStorage.removeItem('OPW_TOKEN');
        window.open('/dashboard/auth', '_self');
      }
    }

    return Promise.reject(error);
  }
);

Vue.prototype.$http = instance;
export default instance;
